import "core-js/modules/es6.array.map";
import React from 'react';
import bem from '../../../_utils/bem';
var blockName = 'breadcrumb';

var Breadcrumbs = function Breadcrumbs(_ref) {
  var items = _ref.items;
  if (!items) return null;
  return /*#__PURE__*/React.createElement("nav", {
    className: bem(blockName, 'wrapper'),
    role: "navigation",
    "aria-labelledby": "system-breadcrumb"
  }, /*#__PURE__*/React.createElement("h2", {
    className: bem('visually-hidden'),
    id: "system-breadcrumb"
  }, "Breadcrumb"), /*#__PURE__*/React.createElement("ol", {
    className: bem(blockName)
  }, items.map(function (item) {
    return /*#__PURE__*/React.createElement("li", {
      className: bem(blockName, 'item')
    }, item.url ? /*#__PURE__*/React.createElement("a", {
      className: bem(blockName, 'link'),
      href: item.url
    }, item.text) : item.text);
  })));
};

export default Breadcrumbs;